import { IncidentFeedModel } from '../../models/IncidentFeedModel'
import FeedConfiguration from './FeedConfiguration'

export const filterCalls = (feedModel: IncidentFeedModel, search: string, configuration: FeedConfiguration) => {
  const searchTerms = search
    .toLowerCase()
    .split(' ')
    .filter(term => term.length !== 0)
  if (
    configuration.callTypes.length === 0 &&
    !configuration.hideMedical &&
    !configuration.hideRecent &&
    searchTerms.length === 0
  ) {
    return feedModel
  } else {
    return new IncidentFeedModel(
      feedModel.alerts,
      feedModel.active
        .filter(i => !configuration.hideMedical || i.callType.category !== 'Medical')
        .filter(i => configuration.callTypes.length === 0 || configuration.callTypes.includes(i.callType))
        .filter(i => i.matchesOnLowerCaseSearchTerms(searchTerms)),
      configuration.hideRecent
        ? []
        : feedModel.recent
            .filter(i => !configuration.hideMedical || i.callType.category !== 'Medical')
            .filter(i => configuration.callTypes.length === 0 || configuration.callTypes.includes(i.callType))
            .filter(i => i.matchesOnLowerCaseSearchTerms(searchTerms))
    )
  }
}
